import { ITask } from 'declarations/task';
import { makeAutoObservable } from 'mobx';

export class TaskStore {

  values: Array<ITask> = [];
  selected: any = {};
  fetchInProgress = false;
  saveInProgress = false;
  deleteInProgress = false;

  constructor() {
    makeAutoObservable(this);
  }

  addValues(values: Array<ITask>): void {
    this.values = values;
  }

  removeValue(resource_id: number): void {
    this.values = this.values.filter((item: ITask) => item.id != resource_id);
  }

  addSelectedValue(value: any): void {
    this.selected = value;
  }

  clearValues(): void {
    this.values = [];
  }

  updateValue(value: ITask): void {
    this.values = this.values.map((item: ITask) => item.id != value.id ? item : value)
  }
  setFetchInProgress(val: boolean) {
    this.fetchInProgress = val;
  }
  setSaveInProgress(val: boolean) {
    this.saveInProgress = val;
  }
  setDeleteInProgress(val: boolean) {
    this.deleteInProgress = val;
  }
}

export default (new TaskStore())
